import { Injectable, Injector } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { tap, map, delay } from 'rxjs/operators';
import { AppConsts } from '@shared/AppConsts';
import { ApplicationService } from '@app/shared/application/application.service';
import { CodeService } from '@app/shared/common/code/code.service';
import { ClaStatus, ClaServiceProxy, ApplicationServiceProxy, GeneralFileInfoDto, GeneralFileDto, GeneralDocumentGroupDto, SponsorshipApplicationServiceProxy,
    CorporateLicenceType, ClaDto, GetClaOutput, GetClaCorporateLicenceDto, ApplicationType, ApplicationUploadFilesInput, GetClaFileInput, GetClaSubItemDocumentsInput,
    ClaInvoiceAddressDto, CreateOrUpdateClaInvoiceAddressInput, ClaInvoiceAddressServiceProxy,
    ClaSponsorshipDto, CreateOrUpdateClaSponsorshipInput, ClaSponsorshipServiceProxy,
    ClaSponsorshipDirectorDto, UpdateClaSponsorshipDirectorsInput, UpdateClaSponsorshipDirectorsOutput,
    ClaDocumentServiceProxy, GetClaDocumentsInput, ClaDocumentsOutput,
    ClaBusinessServiceProxy, ClaBusinessDto, UpdateClaBusinessesInput, UpdateClaBusinessesOutput,
    UpdateClaBusinessDirectorsInput, UpdateClaBusinessDirectorsOutput,
    ClaMedicalFieldDirectorServiceProxy, UpdateClaMedicalFieldDirectorInput, UpdateClaMedicalFieldDirectorOutput, ClaMedicalFieldDirectorDto,
    ClaMedicalFieldDirectorRepresentativeServiceProxy, UpdateClaMedicalFieldDirectorRepresentativeInput, UpdateClaMedicalFieldDirectorRepresentativeOutput, ClaMedicalFieldDirectorRepresentativeDto,
    ClaRangeOfServicesServiceProxy, UpdateClaRangeOfServicesInput, UpdateClaRangeOfServicesOutput,
    ClaInfrastructureServiceProxy, UpdateClaInfrastructureInput, UpdateClaInfrastructureOutput,
    ClaAssistantPhysicianServiceProxy, UpdateClaAssistantPhysiciansOutput, UpdateClaAssistantPhysiciansInput, ClaAssistantPhysicianDto,
    ClaMedicalFieldPersonServiceProxy, ClaMedicalFieldPersonDto, UpdateClaMedicalFieldPersonsInput, UpdateClaMedicalFieldPersonsOutput,
    ClaPersonelServiceProxy, UpdateClaPersonelInput, UpdateClaPersonelOutput,
    ClaTreatmentServiceProxy, UpdateClaTreatmentInput, UpdateClaTreatmentOutput,
    ClaNursingBedsServiceProxy, UpdateClaNursingBedsInput, UpdateClaNursingBedsOutput,
    ClaFloorsServiceProxy, UpdateClaFloorsInput, UpdateClaFloorsOutput,
    ClaAidingResourcesServiceProxy, UpdateClaAidingResourcesInput, UpdateClaAidingResourcesOutput,
    ClaSanitaryFacilitiesServiceProxy, UpdateClaSanitaryFacilitiesInput, UpdateClaSanitaryFacilitiesOutput,
    ClaSecurityServiceProxy, UpdateClaSecurityInput, UpdateClaSecurityOutput,
    ClaQualityServiceProxy, UpdateClaQualityInput, UpdateClaQualityOutput,
    ClaServiceAreasServiceProxy, UpdateClaServiceAreasInput, UpdateClaServiceAreasOutput,
    ClaDrugChambersServiceProxy, UpdateClaDrugChambersInput, UpdateClaDrugChambersOutput,
    ClaWheelchairAccessibilityServiceProxy, UpdateClaWheelchairAccessibilityInput, UpdateClaWheelchairAccessibilityOutput,
    SlasRangeOfProductsServiceProxy, SlasProductPreparationServiceProxy, UpdateSlasRangeOfProductsInput, UpdateSlasRangeOfProductsOutput, UpdateSlasProductPreparationOutput, UpdateSlasProductPreparationInput, UpdateSlasLocalDrugSalesInput, UpdateSlasLocalDrugSalesOutput, SlasLocalDrugSalesServiceProxy, SlasDrugProductionServiceProxy, SlasDrugProductionThirdPartyServiceProxy, UpdateSlasDrugProductionOutput, UpdateSlasDrugProductionInput, UpdateSlasDrugProductionThirdPartyInput, UpdateSlasDrugProductionThirdPartyOutput, OlaOnlineDrugSalesServiceProxy,
    SponsorshipTypeRegisterAffiliationServiceProxy,
    ApplicationStatus,
    SponsorshipApplicationSummaryDto,
    ClaMedicalFieldResponsibleForStorageAndQualityDto,
    ClaMedicalFieldResponsibleForStorageAndQualityServiceProxy,
    UpdateClaMedicalFieldResponsibleForStorageAndQualityInput,
    UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput,
    ClaMedicalFieldResponsibleForHaemovigilanceServiceProxy,
    ClaMedicalFieldResponsibleForHaemovigilanceDto,
    UpdateClaMedicalFieldResponsibleForHaemovigilanceInput,
    UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput,
    ClaTrainerServiceProxy,
    ClaTrainerDto,
    UpdateClaTrainerInput,
    UpdateClaTrainerOutput,
    ClaElectronicPatientRecordDto,
    CreateOrUpdateClaElectronicPatientRecordInput,
    ClaElectronicPatientRecordServiceProxy,
    ClaQualityRequirementDto,
    ClaQualityRequirementServiceProxy,
    CreateOrUpdateClaQualityRequirementInput,
    ClaAuthorizationDto,
    ClaAuthorizationServiceProxy,
    CreateOrUpdateClaAuthorizationInput,
    SetClaOnWaitingAndCreateEhcOutput,
    ClaSelectableCorporateLicenceDto,
    ClaSelectedBusinessDto,
    CreateOrUpdateClaSelectedBusinessesInput,
    ClaBusinessSelectServiceProxy,
    CreateOrUpdateClaSelectedBusinessesOutput,
    ClaSecurityAndInsuranceServiceProxy,
    ClaSecurityAndInsuranceDto,
    CreateOrUpdateClaSecurityAndInsuranceInput,
    ClaRestrictionsServiceProxy,
    CreateOrUpdateClaRestrictionsInput,
    ClaRestrictionDto,
    HealthRegisterIdentificationStatus
} from './../../../shared/service-proxies/service-proxies';
import { SelectItem } from '@node_modules/primeng/api';
import { AppComponentBase } from '@shared/common/app-component-base';

export class ClaInvoiceAddressDetail {
    name!: string | undefined;
    street!: string;
    streetNr!: string | undefined;
    postCode!: string;
    city!: string;
    email!: string;
    countryId!: string | undefined;

    constructor(data?: ClaInvoiceAddressDetail) {
        if (data) {
            for (let property in data) {
                if (data.hasOwnProperty(property)){
                    (<any>this)[property] = (<any>data)[property];
                }
            }
        }
    }
}

@Injectable({providedIn: 'root'})
export class ClaService extends AppComponentBase {

    cla: ClaDto;
    claResultDocuments: GeneralFileInfoDto[];
    sponsorshipApplicationTypes = [ApplicationType.Cla, ApplicationType.ClaRen, ApplicationType.Slas, ApplicationType.SlasRen, ApplicationType.Ola, ApplicationType.OlaRen, ApplicationType.ClaEhc, ApplicationType.Alas] as const;
    private clasForSponsorshipSubject = new ReplaySubject<SponsorshipApplicationSummaryDto[]>(1);
    readonly clasForSponsorship$ = this.clasForSponsorshipSubject.asObservable();

    constructor(
        injector: Injector,
        protected applicationService: ApplicationService,
        protected documentService: ClaDocumentServiceProxy,
        protected codeService: CodeService,
        protected appService: ApplicationServiceProxy,
        protected claService: ClaServiceProxy,
        protected claTypeService: SponsorshipTypeRegisterAffiliationServiceProxy,
        protected claAuthorizationService: ClaAuthorizationServiceProxy,
        protected sponsorshipService: ClaSponsorshipServiceProxy,
        protected medicalFieldDirectorService: ClaMedicalFieldDirectorServiceProxy,
        protected medicalFieldDirectorRepresentativeService: ClaMedicalFieldDirectorRepresentativeServiceProxy,
        protected businessService: ClaBusinessServiceProxy,
        protected rangeOfServicesService: ClaRangeOfServicesServiceProxy,
        protected treatmentService: ClaTreatmentServiceProxy,
        protected nursingBedsService: ClaNursingBedsServiceProxy,
        protected floorsService: ClaFloorsServiceProxy,
        protected sanitaryFacilitiesService: ClaSanitaryFacilitiesServiceProxy,
        protected securityService: ClaSecurityServiceProxy,
        protected drugChambersService: ClaDrugChambersServiceProxy,
        protected aidingResourcesService: ClaAidingResourcesServiceProxy,
        protected wheelchairAccessibilityService: ClaWheelchairAccessibilityServiceProxy,
        protected qualityService: ClaQualityServiceProxy,
        protected personelService: ClaPersonelServiceProxy,
        protected infrastructureService: ClaInfrastructureServiceProxy,
        protected serviceAreasService: ClaServiceAreasServiceProxy,
        protected medicalFieldPersonService: ClaMedicalFieldPersonServiceProxy,
        protected assistantPhysicianService: ClaAssistantPhysicianServiceProxy,
        protected rangeOfProductsService: SlasRangeOfProductsServiceProxy,
        protected productPreparationService: SlasProductPreparationServiceProxy,
        protected localDrugSalesService: SlasLocalDrugSalesServiceProxy,
        protected drugProductionService: SlasDrugProductionServiceProxy,
        protected drugProductionThirdPartyService: SlasDrugProductionThirdPartyServiceProxy,
        protected onlineDrugSalesService: OlaOnlineDrugSalesServiceProxy,
        protected invoiceAddressService: ClaInvoiceAddressServiceProxy,
        protected medicalFieldResponsibleForStorageAndQualityService: ClaMedicalFieldResponsibleForStorageAndQualityServiceProxy,
        protected medicalFieldResponsibleForHaemovigilanceService: ClaMedicalFieldResponsibleForHaemovigilanceServiceProxy,
        protected trainerService: ClaTrainerServiceProxy,
        protected claElectronicPatientRecordService: ClaElectronicPatientRecordServiceProxy,
        protected claQualityRequirementService: ClaQualityRequirementServiceProxy,
        protected businessSelectService: ClaBusinessSelectServiceProxy,
        protected claSecurityAndInsuranceService: ClaSecurityAndInsuranceServiceProxy,
        protected serviceProxy: SponsorshipApplicationServiceProxy,
        protected restrictionService: ClaRestrictionsServiceProxy
    ) {
        super(injector);
    }

    getSponsorshipApplications(filter: string, sorting: string, maxResultCount: number, skipCount: number) {
        return this.serviceProxy.getSponsorshipApplications(filter, sorting, maxResultCount, skipCount);
    }

    getSponsorshipApplicationTypes(allOnTop: boolean) {
        return this.codeService.getEnumForDropdown('ApplicationType', ApplicationType, allOnTop)
            .filter(x => x.value === null || this.sponsorshipApplicationTypes.includes(x.value));
    }

    getCorporateLicenceTypes(allOnTop: boolean) {
        return this.codeService.getEnumForDropdown('CorporateLicenceType', CorporateLicenceType, allOnTop);
    }

    deleteCla(): Observable<void> {
        return this.appService.deleteApplication(this.cla.application.caseId);
    }

    getCla(caseId: string): Observable<GetClaOutput> {
        return this.claService.getCla(caseId).pipe(
            tap((output: GetClaOutput) => {
                this.cla = output.cla;
            })
        );
    }

    closeCla(): void {
        this.cla = null;
    }

    getMyClas(): Observable<SponsorshipApplicationSummaryDto[]> {
        return this.claService.getMyClas();
    }

    loadClasForSponsorship(uid: string): Observable<SponsorshipApplicationSummaryDto[]> {
        if (this.isEmpty(uid)) {
            return of([]);
        }

        return this.claService.getClasForSponsorship(uid).pipe(
            tap(clas => this.clasForSponsorshipSubject.next(clas))
        );
    }

    isInClaStatus(expectedStatus: ClaStatus): boolean {
       return this.cla.statusId === expectedStatus;
    }

    getCorporateLicenceForCla(): Observable<GetClaCorporateLicenceDto> {
        return this.claService.getCorporateLicenceForCla(this.applicationService.caseId);
    }

    getEvaluationComments(): Observable<string> {
        return this.claService.getEvaluationComments(this.applicationService.caseId);
    }

    releaseCla(comment: string): Observable<void> {
        return this.claService.releaseCla(this.cla.application.caseId, comment);
    }

    getNextStatus(status: ClaStatus): Observable<ClaStatus> {

        return this.claService.getNextStatus(this.applicationService.caseId, status).pipe(map(status => {

            // Authority goes to 'finish review' and not to 'release'
            let isAuthority = this.permission.isGranted('Pages.Authority.Applications');
            if (isAuthority && status === ClaStatus.Release) {
                return ClaStatus.FinishReview;
            }

            return status;
        }));
    }

    getStepUrl(nextStep: ClaStatus): string {
        return this.applicationService.getNextStep(ClaService.getUrlForStep(nextStep));
    }

    isEligibleForEhc(): Observable<boolean> {
        return this.claTypeService.isEligibleForEhc(this.cla.sponsorshipTypeId);
    }

    getFiles(step: ClaStatus, hasCorporateLicenceInAnotherCantonId: string = undefined): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaDocumentsInput({ caseId: this.applicationService.caseId, step: step, hasCorporateLicenceInAnotherCantonId: hasCorporateLicenceInAnotherCantonId, hasAppliedForProfessionalLicenceId: undefined, doesCriminalRecordContainAConvictionId: undefined, hasGln: undefined, isAuthorizedSignatoryId: undefined  });
        return this.documentService.getDocuments(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    getFile(step: ClaStatus, id: number): Observable<GeneralFileDto> {
        return this.documentService.getFile(new GetClaFileInput({ caseId: this.applicationService.caseId, step: step, id: id }));
    }

    uploadFiles(input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadFiles(input);
    }

    deleteFile(step: ClaStatus, id: number): Observable<void> {
        return this.documentService.deleteFile(this.applicationService.caseId, step, id);
    }

    get caseId(): string {
        return this.cla.application.caseId;
    }

    get applicationType(): ApplicationType {
        return this.cla.application.type;
    }

    get status(): ApplicationStatus {
        return this.cla.application.status;
    }

    get sponsorshipTypeId(): string {
        return this.cla?.sponsorshipTypeId;
    }

    get name(): string {
        return this.cla.sponsorship?.name;
    }

    get firstStep(): ClaStatus {
            return this.cla.firstStep;
    }

    getSponsorship(): Observable<ClaSponsorshipDto> {
        return of(this.cla.sponsorship).pipe(delay(0));
    }

    getDossierSponsorshipData(): Observable<ClaSponsorshipDto> {
        if (this.cla?.application?.legitimationId) {
            return this.sponsorshipService.getDossierSponsorship(this.cla.application.caseId).pipe();
        } else {
            return of(new ClaSponsorshipDto()).pipe(delay(0));
        }
    }

    getDossierCorporateLicencesData(): Observable<ClaSelectableCorporateLicenceDto[]> {
        return this.sponsorshipService.getDossierCorporateLicences(this.cla.application.caseId);
    }

    createOrUpdateClaSponsorship(input: CreateOrUpdateClaSponsorshipInput): Observable<void> {

        this.applicationService.setStepToReview(ClaStatus.Sponsorship);
        return this.sponsorshipService.createOrUpdateSponsorship(input).pipe(tap((status: ClaStatus) => {
            this.cla.sponsorship = input.sponsorship;
            this.cla.statusId = status;
        }))
            .pipe(map((status: ClaStatus) => null));
    }


    getAuthorization(): Observable<ClaAuthorizationDto> {
        return this.claAuthorizationService.getAuthorization(this.caseId);
        }

    createOrUpdateClaAuthorization(input: CreateOrUpdateClaAuthorizationInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Authorization);
        return this.claAuthorizationService.createOrUpdateAuthorization(input).pipe(tap((status: ClaStatus) => {
            this.cla.authorization = input.authorization;
            this.cla.statusId = status;
        })).pipe(map((status: ClaStatus) => null));
    }

    getAuthorizationFiles(isAuthorizedSignatoryId: string, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.Authorization;
        input.isAuthorizedSignatoryId = isAuthorizedSignatoryId;
        return this.documentService.getDocuments(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadAuthorizationFiles(input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadFiles(input);
    }

    getSecurityAndInsurance(): Observable<ClaSecurityAndInsuranceDto> {
        return this.claSecurityAndInsuranceService.getSecurityAndInsurance(this.caseId);
    }

    createOrUpdateClaSecurityAndInsurance(input: CreateOrUpdateClaSecurityAndInsuranceInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.SecurityAndInsurance);
        return this.claSecurityAndInsuranceService.createOrUpdateSecurityAndInsurance(input).pipe(tap((status: ClaStatus) => {
            this.cla.securityAndInsurance = input.securityAndInsurance;
            this.cla.statusId = status;
        })).pipe(map((status: ClaStatus) => null));
    }

    getSecurityAndInsuranceFiles(caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.SecurityAndInsurance;
        return this.documentService.getDocuments(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadSecurityAndInsuranceFiles(input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadFiles(input);
    }

    getRestrictions(): Observable<ClaRestrictionDto[]> {
        return this.restrictionService.getRestrictions(this.caseId);
    }

    createOrUpdateClaRestrictions(input: CreateOrUpdateClaRestrictionsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Restriction);
        return this.restrictionService.createOrUpdateClaRestrictions(input).pipe(tap((status: ClaStatus) => {
            this.cla.restrictions = input.claRestrictions;
            this.cla.statusId = status;
        })).pipe(map((status: ClaStatus) => null));
    }

    getMedicalFieldDirector(): Observable<ClaMedicalFieldDirectorDto> {
        return this.medicalFieldDirectorService.getMedicalFieldDirector(this.caseId);
    }

    updateMedicalFieldDirector(input: UpdateClaMedicalFieldDirectorInput): Observable<void> {

        this.applicationService.setStepToReview(ClaStatus.MedicalFieldDirector);
        return this.medicalFieldDirectorService.updateMedicalFieldDirector(input).pipe(tap((output: UpdateClaMedicalFieldDirectorOutput) => {
            this.cla.medicalFieldDirector = input.medicalFieldDirector;
            this.cla.statusId = output.status;
            this.cla.medicalFieldDirector = output.medicalFieldDirector;
        }))
            .pipe(map((output: UpdateClaMedicalFieldDirectorOutput) => null));
    }

    getMedicalFieldDirectorFiles(hasAppliedForProfessionalLicenceId: string, doesCriminalRecordContainAConvictionId: string, hasGln: boolean): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaDocumentsInput({ caseId: this.applicationService.caseId, step: ClaStatus.MedicalFieldDirector, hasCorporateLicenceInAnotherCantonId: undefined, hasAppliedForProfessionalLicenceId: hasAppliedForProfessionalLicenceId, doesCriminalRecordContainAConvictionId: doesCriminalRecordContainAConvictionId, hasGln: hasGln, isAuthorizedSignatoryId: undefined  });
        return this.documentService.getMedicalFieldDirectorDocuments(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadMedicalFieldDirectorFiles(input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadMedicalFieldDirectorFiles(input);
    }

    getMedicalFieldDirectorRepresentative(): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        if (this.cla.medicalFieldDirectorRepresentative) {
            return of(this.cla.medicalFieldDirectorRepresentative).pipe(delay(0));
        }

        return this.createPlaceholderMedicalFieldDirectorRepresentative(this.caseId);
    }

    createPlaceholderMedicalFieldDirectorRepresentative(caseId: string): Observable<ClaMedicalFieldDirectorRepresentativeDto> {
        return this.medicalFieldDirectorRepresentativeService.createPlaceholderMedicalFieldDirectorRepresentative(caseId);
    }

    updateMedicalFieldDirectorRepresentative(input: UpdateClaMedicalFieldDirectorRepresentativeInput): Observable<void> {

        this.applicationService.setStepToReview(ClaStatus.MedicalFieldDirectorRepresentative);
        return this.medicalFieldDirectorRepresentativeService.updateMedicalFieldDirectorRepresentative(input).pipe(tap((output: UpdateClaMedicalFieldDirectorRepresentativeOutput) => {
            this.cla.medicalFieldDirectorRepresentative = input.medicalFieldDirectorRepresentative;
            this.cla.statusId = output.status;
            this.cla.medicalFieldDirectorRepresentative = output.medicalFieldDirectorRepresentative;
        }))
            .pipe(map((output: UpdateClaMedicalFieldDirectorRepresentativeOutput) => null));
    }

    getMedicalFieldDirectorRepresentativeFiles(hasAppliedForProfessionalLicenceId: string): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaDocumentsInput({ caseId: this.applicationService.caseId, step: ClaStatus.MedicalFieldDirectorRepresentative, hasCorporateLicenceInAnotherCantonId: undefined, hasAppliedForProfessionalLicenceId: hasAppliedForProfessionalLicenceId, doesCriminalRecordContainAConvictionId: undefined, hasGln: undefined, isAuthorizedSignatoryId: undefined });
        return this.documentService.getMedicalFieldDirectorRepresentativeDocuments(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadMedicalFieldDirectorRepresentativeFiles(input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadMedicalFieldDirectorRepresentativeFiles(input);
    }

    getMedicalFieldResponsibleForStorageAndQuality(): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        if (this.cla.medicalFieldResponsibleForStorageAndQuality) {
            return of(this.cla.medicalFieldResponsibleForStorageAndQuality).pipe(delay(0));
        }

        return this.createPlaceholderMedicalFieldResponsibleForStorageAndQuality(this.caseId);
    }

    createPlaceholderMedicalFieldResponsibleForStorageAndQuality(caseId: string): Observable<ClaMedicalFieldResponsibleForStorageAndQualityDto> {
        return this.medicalFieldResponsibleForStorageAndQualityService.createPlaceholderMedicalFieldResponsibleForStorageAndQuality(caseId);
    }

    updateMedicalFieldResponsibleForStorageAndQuality(input: UpdateClaMedicalFieldResponsibleForStorageAndQualityInput): Observable<void> {

        this.applicationService.setStepToReview(ClaStatus.MedicalFieldResponsibleForStorageAndQuality);
        return this.medicalFieldResponsibleForStorageAndQualityService.updateMedicalFieldResponsibleForStorageAndQuality(input).pipe(tap((output: UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput) => {
            this.cla.statusId = output.status;
            this.cla.medicalFieldResponsibleForStorageAndQuality = output.medicalFieldResponsibleForStorageAndQuality;
        }))
            .pipe(map((output: UpdateClaMedicalFieldResponsibleForStorageAndQualityOutput) => null));
    }

    getMedicalFieldResponsibleForHaemovigilance(): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        if (this.cla.medicalFieldResponsibleForHaemovigilance) {
            return of(this.cla.medicalFieldResponsibleForHaemovigilance).pipe(delay(0));
        }

        return this.createPlaceholderMedicalFieldResponsibleForHaemovigilance(this.caseId);
    }

    createPlaceholderMedicalFieldResponsibleForHaemovigilance(caseId: string): Observable<ClaMedicalFieldResponsibleForHaemovigilanceDto> {
        return this.medicalFieldResponsibleForHaemovigilanceService.createPlaceholderMedicalFieldResponsibleForHaemovigilance(caseId);
    }

    updateMedicalFieldResponsibleForHaemovigilance(input: UpdateClaMedicalFieldResponsibleForHaemovigilanceInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.MedicalFieldResponsibleForHaemovigilance);
        return this.medicalFieldResponsibleForHaemovigilanceService.updateMedicalFieldResponsibleForHaemovigilance(input).pipe(tap((output: UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput) => {
            this.cla.statusId = output.status;
            this.cla.medicalFieldResponsibleForHaemovigilance = output.medicalFieldResponsibleForHaemovigilance;
        }))
            .pipe(map((output: UpdateClaMedicalFieldResponsibleForHaemovigilanceOutput) => null));
    }

    getTrainer(): Observable<ClaTrainerDto> {
        if (this.cla.trainer) {
            return of(this.cla.trainer).pipe(delay(0));
        }

        return this.createPlaceholderTrainer(this.caseId);
    }

    createPlaceholderTrainer(caseId: string): Observable<ClaTrainerDto> {
        return this.trainerService.createPlaceholderTrainer(caseId);
    }

    updateTrainer(input: UpdateClaTrainerInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Trainer);
        return this.trainerService.updateTrainer(input).pipe(tap((output: UpdateClaTrainerOutput) => {
            this.cla.statusId = output.status;
            this.cla.trainer = output.trainer;
        }))
            .pipe(map((output: UpdateClaTrainerOutput) => null));
    }

    getBusinessesForSelection(): Observable<ClaSelectedBusinessDto[]> {
        return this.businessSelectService.getBusinesses(this.caseId);
    }

    createOrUpdateSelectedBusinesses(input: CreateOrUpdateClaSelectedBusinessesInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.BusinessSelect);
        return this.businessSelectService.createOrUpdateSelectedBusinesses(input).pipe(
            tap((output: CreateOrUpdateClaSelectedBusinessesOutput) => {
                this.cla.statusId = output.status;
                // TODO this.cla.selectedBusinesses = output.selectedBusinesses;
            }),
            map((output: CreateOrUpdateClaSelectedBusinessesOutput) => null)
        );
    }

    getSponsorshipDirectors(): Observable<ClaSponsorshipDirectorDto[]> {
        return this.sponsorshipService.getSponsorshipDirectors(this.applicationService.caseId);
    }

    createPlaceholderSponsorshipDirector(caseId: string): Observable<number> {
        return this.sponsorshipService.createPlaceholderSponsorshipDirector(caseId);
    }

    updateSponsorshipDirectors(input: UpdateClaSponsorshipDirectorsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.SponsorshipDirectors);
        return this.sponsorshipService.updateSponsorshipDirectors(input).pipe(tap((output: UpdateClaSponsorshipDirectorsOutput) => {
            this.cla.sponsorshipDirectors = output.directors;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    sponsorshipDirectorRegisterSearch(id: number, gln: string, professionId: string): Observable<HealthRegisterIdentificationStatus> {
        return this.sponsorshipService.sponsorshipDirectorRegisterSearch(this.caseId, id, gln, professionId);
    }

    getSponsorshipDirectorFiles(directorId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.SponsorshipDirectors;
        input.subItemId = directorId;
        return this.documentService.getSponsorshipDirectorFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadSponsorshipDirectorFiles(directorId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadSponsorshipDirectorFiles(directorId, input);
    }

    getBusinesses(): Observable<ClaBusinessDto[]> {
        return this.businessService.getBusinesses(this.caseId);
    }

    createPlaceholderBusiness(caseId: string): Observable<number> {
        return this.businessService.createPlaceholderBusiness(caseId);
    }

    updateBusinesses(input: UpdateClaBusinessesInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Business);
        return this.businessService.updateBusinesses(input).pipe(tap((output: UpdateClaBusinessesOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getBusinessFiles(businessId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.Business;
        input.subItemId = businessId;
        return this.documentService.getBusinessFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadBusinessFiles(businessId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadBusinessFiles(businessId, input);
    }

    getBusinessDirectors(): Observable<ClaBusinessDto[]> {
        return this.businessService.getBusinessDirectors(this.applicationService.caseId);
    }

    createPlaceholderBusinessDirector(caseId: string, businessId: number): Observable<number> {
        return this.businessService.createPlaceholderBusinessDirector(caseId, businessId);
    }

    updateBusinessDirectors(input: UpdateClaBusinessDirectorsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.BusinessDirectors);
        // input.directors.forEach(dir => {
        //     if (dir.isSameAsMedicalFieldManagementId === 'YesNo-Yes') {
        //         dir.levelOfEmployment = this.cla.medicalFieldDirector.levelOfEmployment;
        //         dir.phone1 = this.cla.medicalFieldDirector.phone1;
        //         dir.phone2 = this.cla.medicalFieldDirector.phone2;
        //         dir.email = this.cla.medicalFieldDirector.email;
        //     }
        // });
        return this.businessService.updateBusinessDirectors(input).pipe(tap((output: UpdateClaBusinessDirectorsOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getBusinessDirectorFiles(directorId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.BusinessDirectors;
        input.subItemId = directorId;
        return this.documentService.getBusinessDirectorFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadBusinessDirectorFiles(directorId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadBusinessDirectorFiles(directorId, input);
    }

    getRangeOfServicesList(): Observable<ClaBusinessDto[]> {
        return this.rangeOfServicesService.getRangeOfServicesList(this.applicationService.caseId);
    }

    updateRangeOfServices(input: UpdateClaRangeOfServicesInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.RangeOfServices);
        return this.rangeOfServicesService.updateRangeOfServicesList(input).pipe(tap((output: UpdateClaRangeOfServicesOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getRangeOfServicesFiles(rangeOfServicesId: number, hasXRayMachineId: string, hasOperatingTheatresId: string, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.RangeOfServices;
        input.subItemId = rangeOfServicesId;
        input.hasXRayMachineId = hasXRayMachineId;
        input.hasOperatingTheatresId = hasOperatingTheatresId;
        return this.documentService.getRangeOfServicesFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadRangeOfServicesFiles(rangeOfServicesId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadRangeOfServicesFiles(rangeOfServicesId, input);
    }


    createPlaceholderTreatments(caseId: string, businessId: number): Observable<number> {
        return this.treatmentService.createPlaceholderTreatment(caseId, businessId);
    }

    updateTreatments(input: UpdateClaTreatmentInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Treatment);
        return this.treatmentService.updateTreatmentList(input).pipe(tap((output: UpdateClaTreatmentOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderNursingBeds(caseId: string, businessId: number): Observable<number> {
        return this.nursingBedsService.createPlaceholderNursingBeds(caseId, businessId);
    }

    updateNursingBeds(input: UpdateClaNursingBedsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.NursingBeds);
        return this.nursingBedsService.updateNursingBedsList(input).pipe(tap((output: UpdateClaNursingBedsOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderFloors(caseId: string, businessId: number): Observable<number> {
        return this.floorsService.createPlaceholderFloors(caseId, businessId);
    }

    updateFloors(input: UpdateClaFloorsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Floors);
        return this.floorsService.updateFloorsList(input).pipe(tap((output: UpdateClaFloorsOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderWheelchairAccessibility(caseId: string, businessId: number): Observable<number> {
        return this.wheelchairAccessibilityService.createPlaceholderWheelchairAccessibility(caseId, businessId);
    }

    updateWheelchairAccessibility(input: UpdateClaWheelchairAccessibilityInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.WheelchairAccessibility);
        return this.wheelchairAccessibilityService.updateWheelchairAccessibilityList(input).pipe(tap((output: UpdateClaWheelchairAccessibilityOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderSecurity(caseId: string, businessId: number): Observable<number> {
        return this.securityService.createPlaceholderSecurity(caseId, businessId);
    }

    updateSecurity(input: UpdateClaSecurityInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Security);
        return this.securityService.updateSecurityList(input).pipe(tap((output: UpdateClaSecurityOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getSecurityFiles(securityId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.Security;
        input.subItemId = securityId;
        return this.documentService.getSecurityFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadSecurityFiles(securityId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadSecurityFiles(securityId, input);
    }

    createPlaceholderAidingResources(caseId: string, businessId: number): Observable<number> {
        return this.aidingResourcesService.createPlaceholderAidingResources(caseId, businessId);
    }

    updateAidingResources(input: UpdateClaAidingResourcesInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.AidingResources);
        return this.aidingResourcesService.updateAidingResourcesList(input).pipe(tap((output: UpdateClaAidingResourcesOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderDrugChambers(caseId: string, businessId: number): Observable<number> {
        return this.drugChambersService.createPlaceholderDrugChambers(caseId, businessId);
    }

    updateDrugChambers(input: UpdateClaDrugChambersInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.DrugChambers);
        return this.drugChambersService.updateDrugChambersList(input).pipe(tap((output: UpdateClaDrugChambersOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderSanitaryFacilities(caseId: string, businessId: number): Observable<number> {
        return this.sanitaryFacilitiesService.createPlaceholderSanitaryFacilities(caseId, businessId);
    }

    updateSanitaryFacilities(input: UpdateClaSanitaryFacilitiesInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.NursingBeds);
        return this.sanitaryFacilitiesService.updateSanitaryFacilitiesList(input).pipe(tap((output: UpdateClaSanitaryFacilitiesOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderQuality(caseId: string, businessId: number): Observable<number> {
        return this.qualityService.createPlaceholderQuality(caseId, businessId);
    }

    updateQuality(input: UpdateClaQualityInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Quality);
        return this.qualityService.updateQualityList(input).pipe(tap((output: UpdateClaQualityOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

     createPlaceholderServiceArea(caseId: string, businessId: number): Observable<number> {
         return this.serviceAreasService.createPlaceholderServiceArea(caseId, businessId);
     }

     updateServiceArea(input: UpdateClaServiceAreasInput): Observable<void> {
         this.applicationService.setStepToReview(ClaStatus.ServiceArea);
         return this.serviceAreasService.updateServiceAreasList(input).pipe(tap((output: UpdateClaServiceAreasOutput) => {
             this.cla.businesses = output.businesses;
             this.cla.statusId = output.status;
         })).pipe(map(() => null));
     }

     getPersonelList(): Observable<ClaBusinessDto[]> {
        return this.personelService.getPersonelList(this.applicationService.caseId);
    }

    updatePersonel(input: UpdateClaPersonelInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Personel);
        return this.personelService.updatePersonelList(input).pipe(tap((output: UpdateClaPersonelOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getPersonelFiles(personelId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.Personel;
        input.subItemId = personelId;
        return this.documentService.getPersonelFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadPersonelFiles(personelId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadPersonelFiles(personelId, input);
    }

    getInfrastructureList(): Observable<ClaBusinessDto[]> {
        return this.infrastructureService.getInfrastructureList(this.applicationService.caseId);
    }

    updateInfrastructure(input: UpdateClaInfrastructureInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.Infrastructure);
        return this.infrastructureService.updateInfrastructureList(input).pipe(tap((output: UpdateClaInfrastructureOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getInfrastructureFiles(infrastructureId: number, hasConstructionalMeasuresId: string, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.Infrastructure;
        input.subItemId = infrastructureId;
        input.hasConstructionalMeasuresId = hasConstructionalMeasuresId;
        return this.documentService.getInfrastructureFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadInfrastructureFiles(infrastructureId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadInfrastructureFiles(infrastructureId, input);
    }

    getMedicalFieldPersons(): Observable<ClaMedicalFieldPersonDto[]> {
        return this.medicalFieldPersonService.getMedicalFieldPersons(this.caseId);
    }

    createPlaceholderMedicalFieldPerson(caseId: string): Observable<number> {
        return this.medicalFieldPersonService.createPlaceholderMedicalFieldPerson(caseId);
    }

    updateMedicalFieldPersons(input: UpdateClaMedicalFieldPersonsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.MedicalFieldPerson);
        return this.medicalFieldPersonService.updateMedicalFieldPersons(input).pipe(tap((output: UpdateClaMedicalFieldPersonsOutput) => {
            this.cla.medicalFieldPersons = output.medicalFieldPersons;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getMedicalFieldPersonFiles(medicalFieldPersonId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.MedicalFieldPerson;
        input.subItemId = medicalFieldPersonId;
        return this.documentService.getMedicalFieldPersonFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadMedicalFieldPersonFiles(medicalFieldPersonId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadMedicalFieldPersonFiles(medicalFieldPersonId, input);
    }

    getAssistantPhysicians(): Observable<ClaAssistantPhysicianDto[]> {
        return this.assistantPhysicianService.getAssistantPhysicians(this.caseId);
    }

    createPlaceholderAssistantPhysician(caseId: string): Observable<number> {
        return this.assistantPhysicianService.createPlaceholderAssistantPhysician(caseId);
    }

    updateAssistantPhysicians(input: UpdateClaAssistantPhysiciansInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.AssistantPhysicians);
        return this.assistantPhysicianService.updateAssistantPhysicians(input).pipe(tap((output: UpdateClaAssistantPhysiciansOutput) => {
            this.cla.assistantPhysicians = output.assistantPhysicians;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getAssistantPhysicianFiles(assistantPhysicianId: number, hasAssistantsLicenceId: string, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.AssistantPhysicians;
        input.subItemId = assistantPhysicianId;
        input.hasAssistantsLicenceId = hasAssistantsLicenceId;
        return this.documentService.getAssistantPhysicianFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadAssistantPhysicianFiles(assistantPhysicianId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadAssistantPhysicianFiles(assistantPhysicianId, input);
    }

    createPlaceholderRangeOfProducts(caseId: string, businessId: number): Observable<number> {
        return this.rangeOfProductsService.createPlaceholderRangeOfProducts(caseId, businessId);
    }

    updateRangeOfProducts(input: UpdateSlasRangeOfProductsInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.RangeOfProducts);
        return this.rangeOfProductsService.updateRangeOfProductsList(input).pipe(tap((output: UpdateSlasRangeOfProductsOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getRangeOfProductsFiles(rangeOfProductsId: number, hasXRayMachineId: string, hasOperatingTheatresId: string, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.RangeOfProducts;
        input.subItemId = rangeOfProductsId;
        input.hasXRayMachineId = hasXRayMachineId;
        input.hasOperatingTheatresId = hasOperatingTheatresId;
        return this.documentService.getRangeOfProductsFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadRangeOfProductsFiles(rangeOfProductsId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadRangeOfProductsFiles(rangeOfProductsId, input);
    }

    createPlaceholderProductPreparation(caseId: string, businessId: number): Observable<number> {
        return this.productPreparationService.createPlaceholderProductPreparation(caseId, businessId);
    }

    updateProductPreparation(input: UpdateSlasProductPreparationInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.ProductPreparation);
        return this.productPreparationService.updateProductPreparationList(input).pipe(tap((output: UpdateSlasProductPreparationOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    createPlaceholderLocalDrugSales(caseId: string, businessId: number): Observable<number> {
        return this.localDrugSalesService.createPlaceholderLocalDrugSales(caseId, businessId);
    }

    updateLocalDrugSales(input: UpdateSlasLocalDrugSalesInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.LocalDrugSales);
        return this.localDrugSalesService.updateLocalDrugSalesList(input).pipe(tap((output: UpdateSlasLocalDrugSalesOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getDrugProduction(): Observable<ClaBusinessDto[]> {
        return this.drugProductionService.getDrugProduction(this.caseId);
    }

    updateDrugProduction(input: UpdateSlasDrugProductionInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.DrugProduction);
        return this.drugProductionService.updateDrugProductionList(input).pipe(tap((output: UpdateSlasDrugProductionOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    getDrugProductionFiles(drugProductionId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.DrugProduction;
        input.subItemId = drugProductionId;
        return this.documentService.getDrugProductionFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadDrugProductionFiles(drugProductionId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadDrugProductionFiles(drugProductionId, input);
    }

    createPlaceholderDrugProductionThirdParty(caseId: string, businessId: number): Observable<number> {
        return this.drugProductionThirdPartyService.createPlaceholderDrugProductionThirdParty(caseId, businessId);
    }

    updateDrugProductionThirdParty(input: UpdateSlasDrugProductionThirdPartyInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.DrugProductionThirdParty);
        return this.drugProductionThirdPartyService.updateDrugProductionThirdPartyList(input).pipe(tap((output: UpdateSlasDrugProductionThirdPartyOutput) => {
            this.cla.businesses = output.businesses;
            this.cla.statusId = output.status;
        })).pipe(map(() => null));
    }

    completeOnlineDrugSales(): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.OnlineDrugSales);
        return this.onlineDrugSalesService.completeOnlineDrugSales(this.caseId).pipe(tap((statusId: ClaStatus) => {
            this.cla.statusId = statusId;
        })).pipe(map(() => null));
    }

    getOnlineDrugSalesFiles(onlineDrugSalesId: number, caseId = this.applicationService.caseId): Observable<GeneralDocumentGroupDto[]> {
        const input = new GetClaSubItemDocumentsInput();
        input.caseId = caseId;
        input.step = ClaStatus.OnlineDrugSales;
        input.subItemId = onlineDrugSalesId;
        return this.documentService.getOnlineDrugSalesFiles(input).pipe(map((output: ClaDocumentsOutput) => output.documents));
    }

    uploadOnlineDrugSalesFiles(onlineDrugSalesId: number, input: ApplicationUploadFilesInput): Observable<GeneralFileInfoDto[]> {
        return this.documentService.uploadOnlineDrugSalesFiles(onlineDrugSalesId, input);
    }

    getInvoiceAddress(): Observable<ClaInvoiceAddressDto> {
        return this.invoiceAddressService.getInvoiceAddress(this.caseId);
    }

    getClaElectronicPatientRecord(): Observable<ClaElectronicPatientRecordDto> {
            return of(this.cla.claElectronicPatientRecord).pipe(delay(0));
        }

    createOrUpdateClaElectronicPatientRecord(input: CreateOrUpdateClaElectronicPatientRecordInput): Observable<void> {
            this.applicationService.setStepToReview(ClaStatus.ElectronicPatientRecord);
            return this.claElectronicPatientRecordService.createOrUpdateClaElectronicPatientRecord(input).pipe(tap((status: ClaStatus) => {
                this.cla.claElectronicPatientRecord = input.claElectronicPatientRecord;
                this.cla.statusId = status;
            })).pipe(map((status: ClaStatus) => null));
        }

    createOrUpdateClaQualityRequirement(input: CreateOrUpdateClaQualityRequirementInput): Observable<void> {
            this.applicationService.setStepToReview(ClaStatus.QualityRequirement);
            return this.claQualityRequirementService
                .createOrUpdateClaQualityRequirement(input)
                .pipe(
                    tap((status: ClaStatus) => {
                        this.cla.claQualityRequirement = input.claQualityRequirement;
                        this.cla.statusId = status;
                    })
                )
                .pipe(map((status: ClaStatus) => null));
        }

    getClaQualityRequirement(): Observable<ClaQualityRequirementDto> {
        return of(this.cla.claQualityRequirement).pipe(delay(0));
    }

    createOrUpdateClaInvoiceAddress(input: CreateOrUpdateClaInvoiceAddressInput): Observable<void> {
        this.applicationService.setStepToReview(ClaStatus.InvoiceAddress);
        return this.invoiceAddressService.createOrUpdateClaInvoiceAddress(input).pipe(tap((statusId: ClaStatus) => {
            this.cla.invoiceAddress = input.claInvoiceAddress;
            this.cla.statusId = statusId;
        }))
            .pipe(map((_statusId: ClaStatus) => null));
    }

    createAddressDropdownList(): SelectItem[] {
        let addresses: SelectItem[] = [];

        addresses.push({ value: AppConsts.codes.address.sponsorship, label: this.l('Address-Sponsorship') + ': ' + this.getSponsorshipAddressDescription(this.cla.sponsorship != null ? this.cla.sponsorship : this.cla.parentSponsorship) });

        for (let j = 0; j < this.cla.businesses?.length; j++) {
            addresses.push({ value: this.cla.businesses[j].id, label: this.l('Address-Businesses') + ': ' + this.getBusinessAddressDescription(this.cla.businesses[j]) });
        }

        if (addresses.length > 0) {
            addresses.push({ value: AppConsts.codes.address.invoice, label: this.l(AppConsts.codes.address.invoice) });
        }

        return addresses;
    }

    private getSponsorshipAddressDescription(sponsorship: ClaSponsorshipDto): string {
        let str = sponsorship?.street;
        if (sponsorship?.streetNr && sponsorship.streetNr.length > 0) {
            str = str.concat(' ');
            str = str.concat(sponsorship.streetNr);
        }
        str = str?.concat(', ');
        str = str?.concat(sponsorship?.city);
        return str;
    }

    private getBusinessAddressDescription(business: ClaBusinessDto): string {
        let str = business?.name;
        str = str?.concat(': ');
        str = str?.concat(business?.street);

        if (business?.streetNr && business.streetNr.length > 0) {
            str = str.concat(' ');
            str = str.concat(business.streetNr);
        }

        str = str?.concat(', ');
        str = str?.concat(business?.city);

        return str;
    }

    checkDocuments(): Observable<ClaStatus[]> {
        return this.claService.validateThatAllMandatoryDocumentsHaveBeenUploaded(this.caseId);
    }


    getAlternativeTitleBySponsorshipType(sponsorshipTypeId: string, defaultTitle: string): string {
        switch (defaultTitle) {
            case 'AssistantPhysician':
                switch (sponsorshipTypeId) {
                    case this.codes.sponsorshipType.outpatientDentalClinic:
                    case this.codes.sponsorshipType.outpatientDentalClinic:
                        return 'AssistantDentist';
                    case this.codes.sponsorshipType.outpatientChiropractorClinic:
                        return 'AssistantChiropractor';
                    default:
                        return defaultTitle;
                }

            case 'MedicalFieldPhysician':
                switch (sponsorshipTypeId) {
                    case this.codes.sponsorshipType.outpatientDentalClinic:
                    case this.codes.sponsorshipType.outpatientDentalClinic:
                        return 'MedicalFieldDentist';
                    case this.codes.sponsorshipType.outpatientChiropractorClinic:
                        return 'MedicalFieldChiropractor';
                    default:
                        return defaultTitle;
                }
            default:
                return defaultTitle;
        }
    }

    static getUrlForStep(step: ClaStatus): string {
        switch (step) {
            case ClaStatus.Sponsorship:
                return 'sponsorship';
            case ClaStatus.Authorization:
                    return 'authorization';
            case ClaStatus.SponsorshipDirectors:
                return 'sponsorship-directors';
            case ClaStatus.MedicalFieldDirector:
                return 'medical-field-director';
            case ClaStatus.MedicalFieldDirectorRepresentative:
                return 'medical-field-director-representative';
            case ClaStatus.Business:
                return 'businesses';
            case ClaStatus.BusinessSelect:
                return 'businesses-select';
            case ClaStatus.BusinessDirectors:
                return 'business-directors';
            case ClaStatus.RangeOfServices:
                return 'range-of-services';
            case ClaStatus.Treatment:
                return 'treatment';
            case ClaStatus.NursingBeds:
                return 'nursing-beds';
            case ClaStatus.Floors:
                return 'floors';
            case ClaStatus.WheelchairAccessibility:
                return 'wheelchair-accessibility';
            case ClaStatus.AidingResources:
                return 'aiding-resources';
            case ClaStatus.DrugChambers:
                return 'drug-chambers';
            case ClaStatus.Security:
                return 'security';
            case ClaStatus.SanitaryFacilities:
                return 'sanitary-facilities';
            case ClaStatus.Infrastructure:
                return 'infrastructure';
            case ClaStatus.ServiceArea:
                return 'service-area';
            case ClaStatus.Personel:
                return 'personel';
            case ClaStatus.Quality:
                return 'quality';
            case ClaStatus.QualityRequirement:
                return 'quality-requirement';
            case ClaStatus.ElectronicPatientRecord:
                return 'electronic-patient-record';
            case ClaStatus.MedicalFieldPerson:
                return 'medical-field-person';
            case ClaStatus.AssistantPhysicians:
                return 'assistant-physician';
            case ClaStatus.RangeOfProducts:
                return 'range-of-products';
            case ClaStatus.ProductPreparation:
                return 'product-preparation';
            case ClaStatus.LocalDrugSales:
                return 'local-drug-sales';
            case ClaStatus.DrugProduction:
                return 'drug-production';
            case ClaStatus.DrugProductionThirdParty:
                return 'drug-production-third-party';
            case ClaStatus.OnlineDrugSales:
                return 'online-drug-sales';
            case ClaStatus.InvoiceAddress:
                return 'invoice-address';
            case ClaStatus.MedicalFieldResponsibleForStorageAndQuality:
                return 'medical-field-responsible-for-storage-and-quality';
            case ClaStatus.MedicalFieldResponsibleForHaemovigilance:
                return 'medical-field-responsible-for-haemovigilance';
            case ClaStatus.Trainer:
                return 'trainer';
            case ClaStatus.CurrentAssistantsAlas:
                return 'current-assistants-alas';
            case ClaStatus.MedicalFieldPersonAlas:
                return 'medical-field-person-alas';
            case ClaStatus.PersonAlas:
                return 'person-alas';
            case ClaStatus.ContactAlas:
                return 'contact-alas';
            case ClaStatus.DiplomaAlas:
                return 'diploma-alas';
            case ClaStatus.LanguageSkillAlas:
                return 'language-skill-alas';
            case ClaStatus.RestrictionAlas:
                return 'restriction-alas';
            case ClaStatus.AcademicTitleAlas:
                return 'academic-title-alas';
            case ClaStatus.BusinessAlas:
                return 'business-alas';
            case ClaStatus.EmploymentAlas:
                return 'employment-alas';
            case ClaStatus.SecurityAndInsurance:
                return 'security-and-insurance';
            case ClaStatus.Restriction:
                return 'restriction';
            case ClaStatus.Release:
                return 'release';
            case ClaStatus.FinishReview:
                return 'finish-review';
            default:
                console.error('Invalid status for getUrlForStep');
                return null;
        }
    }

    setClaOnWaitingAndCreateEhc(comment: string): Observable<SetClaOnWaitingAndCreateEhcOutput> {
        return this.claService.setClaOnWaitingAndCreateEhc(this.cla.application.caseId, comment);
    }

    hasLinkedCla(): Observable<boolean> {
        return this.claService.hasLinkedCla(this.cla.application.caseId);
    }

    releaseCombinedApplications(comment: string, releaseAction: string): Observable<void> {
        return this.claService.releaseCombinedApplications(this.cla.application.caseId, comment, releaseAction);
    }

}
